module.exports = __webpack_public_path__ + "static/media/logomark.9bd93869.png";